<template>
	<div id="zhuyinggoucheng" class="oh" v-show="hasData">
		<div>
			<div class="land-ecahrt-title w95mg ">
				<span :class="mainTableType == i ? 'current title fl' : 'title fl'" v-for="(key, i) in typeArry"
					:key="i" @click="mainTableType = i; chooseType()">{{ key }}</span>
			</div>
			<div class="market-box w95mg oh" v-show="mainTableType == 'market'">
				<div v-for="(list, i) in localDataType.market" :key="i" class="fl market-list mb-2">
					<h4 class="mt-1 market-title" @click="routerblank('/marketDetail?type=1&id='+list.id)">{{ list.title }}</h4>
					<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'bar_charts_' + i"></div>
				</div>
			    <p class="text-center my-2 curp widthPC-100 font-18" @click="routerblank('/industryLibrary?type=2')">更多信息 ></p>

			</div>
			<div class="market-box w95mg oh" v-show="mainTableType == 'compete'">
				<div v-for="(list, i) in localDataType.compete" :key="i" class="fl market-list mb-2">
					<h4 class="mt-1 market-title" @click="routerblank('/marketDetail?type=2&id='+list.id)">{{ list.title }}</h4>
					<div style="width: 90%;height: 290px;margin: 0 auto;" :id="'pie_charts_' + i"></div>
				</div>
			    <p class="text-center my-2 curp widthPC-100 font-18" @click="routerblank('/industryLibrary?type=3')">更多信息 ></p>
			</div>
		</div>
	</div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"

export default {
	name: 'industryData',
	data() {
		return {
			titleh: "企业详情页--产业数据",
			mainTableType: '',
			hasData: false,
			typeArry: { market: "市场规模", compete: "竞争格局" },
			localDataType: {
				market: [],
				compete: [],
			},
			marketList: [],
			compete: [],
		}
	},
	props: {
		mergeList: {},
		isFree: {
			type: Boolean,
			default: false
		},
	},
	components: { freeUserTips },
	created() {
	},
	mounted() {
		setTimeout(() => {
			if (Object.keys(this.mergeList).length != 0) {
				this.init();
			}
		}, 1500)
	},
	methods: {
		init() {
			this.localDataType.market = this.mergeList.market;
			this.localDataType.compete = this.mergeList.compete;
			console.log(this.localDataType);
			for (var key in this.typeArry) {
				console.log(this.typeArry[key], key);
				if (this.typeArry[key].length > 0) {
					this.hasData = true;
					this.mainTableType = key;
					break;
				}
			}
			this.chooseType();

		},
		chooseType() {
			let tempMarket = this.localDataType.market;
			let tempCompete = this.localDataType.compete;
			if (this.mainTableType == 'market') {
				console.log('market', tempMarket);
				tempMarket.forEach((list, i) => {
					this.drawShape('bar_charts_' + i, list.dataList, list.legendName, list.unit);
				})
			} else if (this.mainTableType == 'compete') {
				console.log('compete', tempCompete);
				tempCompete.forEach((list, i) => {
					this.$nextTick(() => {
						this.pieCharts('pie_charts_' + i, list.dataList, list.unit);
					})
				})
			}
		},
		pieCharts(el, data, unit) {
			console.log(el, data);
			let seriesData = [];
			var trendchart = echarts.init(document.getElementById(el));
			for (var i = 0; i < data.length; i++) {
				data[i].name = data[i].label;
				if (data[i].label == '其他') {
					var ortherData = data[i]
					// console.log(data[i]);
				} else {
					seriesData.push(data[i]);
				}
			}
			if (typeof ortherData === 'object' && ortherData !== null && Object.keys(ortherData).length > 0) {
				seriesData.push(ortherData);
				// console.log(ortherData,seriesData,data);
			}
			var option = {
				tooltip: {
					trigger: 'item',
					formatter: '{b0}: {c0} ' + unit
				},
				legend: {
					right: '0',
					top: 'center',
					orient: 'vertical', // 设置图例竖排
					type: 'scroll', //图例强制不换行（滚动）
					width: '70%',
					formatter: (name) => {
						// console.log(name);
						if (!name) return '';
						let tempStr = this.getEqualNewlineString(name, 10);
						for (let i = 0; i < seriesData.length; i++) {
							// console.log(seriesData[i].name, name);
							if (seriesData[i].name == name && seriesData[i].stockCode != 0) {
								return '{a|' + tempStr + '}'; // 使用{a|text}语法来表示下划线
							} else if (seriesData[i].name == name && seriesData[i].stockCode == 0) {
								return tempStr;

							}
						}
					},
					textStyle: {
						rich: {
							a: {
								color: '#598df5',
								lineHeight: 22,
								align: 'center',
								fontSize: 12,
								borderWidth: 0.5,
								decoration: 'underline' // 设置下划线
							}
						}
					}
				},
				series: [
					{
						name: '',
						type: 'pie',
						// radius: ['40%', '70%'],
						center: ['35%', '50%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						labelLine: {
							show: false
						},
						data: seriesData,
						itemStyle: {
							normal: {
								borderColor: '#ffffff', // 发光颜色
								// borderWidth: 5,       // 发光宽度
								// shadowBlur: 10,       // 阴影模糊大小
								// shadowColor: '#f7f3ff'  // 阴影颜色
							}
						},
					}
				],
			};
			trendchart.setOption(option);
			// 饼图图例点击跳转到指定页面
			trendchart.on('legendselectchanged', (param) => {

				// console.log(param)
				for (let i = 0; i < seriesData.length; i++) {
					if (param.name == seriesData[i].name && seriesData[i].stockCode != 0 && seriesData[i].table != 0) {
						trendchart.setOption({
							legend: { selected: { [param.name]: true } } //让图例点击后不变灰
						});
						if (seriesData[i].table != 4) {
							this.routerlinkid('/enterprises', seriesData[i].stockCode);
						} else {
							this.routerlinkid('/enterprisesF', seriesData[i].stockCode);
						}
					}
				}
			});
			// trendchart.on('click',  (param)=> {
			// 	console.log(param)
			// 	if(param.data.stockCode !=''&& param.data.table != 0){
			// 		if(param.data.table != 4){
			// 			this.routerlinkid('/enterprises',param.data.stockCode);
			// 		}else {
			// 			this.routerlinkid('/enterprisesF',param.data.stockCode);
			// 		}
			// 	}
			// });
		},
		drawShape(el, data, legendName, unit) {
			console.log(el, data, legendName, unit);
			let xAxisText = [];
			let barData = [], //柱状
				lineData = []; //折线
			for (var i = 0; i < data.length; i++) {
				xAxisText.push(data[i].label);
				barData.push(data[i].value);
				lineData.push(data[i].tb);
			}
			// 创建立方体正面图形
			const cubeShape1 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: 10, // 长方体宽度
					zWidth: 2, // 阴影折角高
					zHeight: 4 // 阴影折角宽
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const xAxisPoint = api.coord([shape.xValue, 0])
					const p0 = [shape.x, shape.y]
					const p1 = [shape.x - shape.width, shape.y]
					const p4 = [shape.x + shape.width, shape.y]
					const p2 = [
						xAxisPoint[0] - shape.width,
						xAxisPoint[1]
					]
					const p3 = [
						xAxisPoint[0] + shape.width,
						xAxisPoint[1]
					]

					// 绘制正面
					ctx.moveTo(p0[0], p0[1]) //0
					ctx.lineTo(p1[0], p1[1]) //1
					ctx.lineTo(p2[0], p2[1]) //2
					ctx.lineTo(p3[0], p3[1]) //3
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.lineTo(p0[0], p0[1]) //0
					ctx.closePath()
				}
			})

			// 创建立方体的侧面
			const cubeShape2 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: 10, // 长方体宽度
					zWidth: 4, // 阴影折角高
					zHeight: 1 // 阴影折角宽
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const xAxisPoint = api.coord([shape.xValue, 0])
					const p4 = [shape.x + shape.width, shape.y]
					const p6 = [
						shape.x + shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					const p3 = [
						xAxisPoint[0] + shape.width,
						xAxisPoint[1]
					]
					const p5 = [
						xAxisPoint[0] + shape.width + shape.zWidth,
						xAxisPoint[1] - shape.zHeight
					]

					// 绘制侧面
					ctx.moveTo(p4[0], p4[1]) //4
					ctx.lineTo(p3[0], p3[1]) //3
					ctx.lineTo(p5[0] + 6, p5[1] - 6) //5
					ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.closePath()
				}
			})
			// 创建立方体的顶
			const cubeShape3 = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0,
					width: 10,
					zWidth: 4,
					zHeight: 1
				},
				buildPath: (ctx, shape) => {
					const api = shape.api
					const p1 = [shape.x - shape.width, shape.y]
					const p4 = [shape.x + shape.width, shape.y]
					const p6 = [
						shape.x + shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					const p7 = [
						shape.x - shape.width + shape.zWidth,
						shape.y - shape.zHeight
					]
					// 绘制顶部
					ctx.moveTo(p4[0], p4[1]) //4
					ctx.lineTo(p6[0] + 7, p6[1] - 8) //6
					ctx.lineTo(p7[0] + 7, p7[1] - 8) //7
					ctx.lineTo(p1[0], p1[1]) //1
					ctx.lineTo(p4[0], p4[1]) //4
					ctx.closePath()
				}
			})

			echarts.graphic.registerShape('cubeShape1', cubeShape1);
			echarts.graphic.registerShape('cubeShape2', cubeShape2);
			echarts.graphic.registerShape('cubeShape3', cubeShape3);
			this.$nextTick(() => {
				this.initECharts(el, xAxisText, lineData, barData, legendName, unit);
			})

		},
		initECharts(el, xdata, lineData, barData, legendName, unit) {
			var mychart = echarts.init(document.getElementById(el));
			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					grid: {
						top: '100%',
						// containLabel: true // 包含标签
					},
					// confine:true, //是否将提示框限制在图表的区域内
					appendToBody: true, //是否将提示框放置在body元素上
					formatter: function (params) {
						// console.log(params);
						var result = ''
						var name = params[0].name + "</br>";
						var dotHtml = '', dotHtml2 = '', unitd = params[0].componentSubType == "line" ? ' %' : unit;
						if (params[0]) {
							dotHtml = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[0].color + '"></span> ' + params[0].seriesName + "： " + params[0].data + ' ' + unitd + "</br>"; // 定义第一个数据前的圆点颜色	
						}
						if (params[1]) {
							dotHtml2 = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + params[1].color + '"></span>' + params[1].seriesName + "： " + params[1].data + ' %';
						}

						result += name + dotHtml + dotHtml2;
						return result
					},
				},
				legend: {
					show: true,
					bottom: "5%",
				},
				xAxis: {
					type: 'category',
					data: xdata,
					interval: 0,
					axisLine: {
						onZero: false,
					}
					// axisLabel: { color: '#333', interval: 0, rotate: 50 }
				},
				yAxis: [
					{
						type: 'value',
						name: '',
						boundaryGap: false,
						// step:
						axisTick: {
							"show": true
						},
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						splitLine: {
							show: false
						}, //不显示分割线
					},
					{
						type: 'value',
						name: ' ',
						axisTick: {
							"show": true
						},
						splitLine: {
							show: false
						}, //不显示分割线
						axisLine: {
							show: true,
						}, //显示y轴刻度线
						axisLabel: {
							// 使用 formatter 属性来格式化标签文本
							formatter: '{value} %' // 在这里添加单位
						}
					}
				],
				series: [
					{
						type: 'custom',
						name: legendName + unit,
						color: 'rgb(96, 147, 218)',
						renderItem: (params, api) => {
							// console.log(params,api)
							let location = api.coord([api.value(0), api.value(1)]);
							return {
								type: 'group',
								children: [{
									type: 'cubeShape1', // 正方体正面
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(96, 147, 218)'
									}
								},
								{
									type: 'cubeShape2', // 正方体侧面
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(84,128,191)'
									}
								},
								{
									type: 'cubeShape3', // 正方体顶
									shape: {
										api,
										xValue: api.value(0),
										yValue: api.value(1),
										x: location[0],
										y: location[1]
									},
									style: {
										fill: 'rgb(104, 161, 236)'
									}
								},
								]
							}
						},
						yAxisIndex: 0, // 这里指定使用第一个 Y 轴
						data: barData,
					},
					{
						name: 'YOY',
						type: 'line',
						yAxisIndex: 1,
						color: '#ffaf25',
						data: lineData
					}
				]
			}
			mychart.setOption(option)
		},
		//params 要处理的字符串
		//length 每行显示长度
		getEqualNewlineString(params, length) {
			let text = ''
			let count = Math.ceil(params.length / length) // 向上取整数
			// 一行展示length个
			if (count > 1) {
				for (let z = 1; z <= count; z++) {
					text += params.substr((z - 1) * length, length)
					if (z < count) {
						text += '\n'
					}
				}
			} else {
				text += params.substr(0, length)
			}
			return text
		},
	}
};
</script>

<style lang="scss" scoped>
.pagetable1 {
	margin-bottom: 20px;
}

.endsm_title1 {
	border-left: 8px solid #3e7bfa;
	line-height: 20px;
	padding-left: 14px;
	margin: 30px 0 30px;
}

#mainPieProduct,
#mainPieArea,
#mainPieHy {
	width: 30%;
	height: 400px;
	background: #fff;
	border: 1px solid #eee;
}

.curTableDate {
	width: 150px;
	margin-left: 100px;
}

.container-flex-center img {
	max-width: 95%;
	max-height: 95%;
}

.el-dialog__headerbtn {
	font-size: 30px;
	font-weight: bold;
}

.pop-box {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	border: 1px solid red;
	z-index: 99999;
}

.market-list {
	width: calc(33% - 35px);
	height: 365px;
	cursor: pointer;
	overflow: hidden;
	transition: all .3s;
	border: 1px solid #eee;
	margin-right: 35px;
	border-radius: 8px;
}

.market-list:hover {
	/* background: #f3f7ff; */
	border-radius: 8px;

}

.image-card {
	height: 270px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.market-title {
	padding: 20px 20px 0 20px;
	height: 48px;
	/* display: flex; */
	/* align-items: center; */
	/* overflow: hidden; */
}

.font-size14 {
	font-size: 14px;
}
</style>